<script>
import appConfig from "@/app.config";
import axios from "axios";
import Swal from "sweetalert2";
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { menuItems } from "@/components/menu-static";

export default {
  page: {
    title: "Login Cermat",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {},
  data() {
    return {
      username: this.$route.query.username ?? "",
      role_name: this.$route.query.role_name ?? "",
      token: this.$route.query.token ?? "",
      configuration: [],
    };
  },
  computed: {
    ...mapState("authfack", ["status"]),
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
  },
  mounted() {
    Swal.fire({
      title: '<i class="fas fa-spinner fa-spin"></i>',
      text: "Loading...",
      showConfirmButton: false,
      allowOutsideClick: false,
    });
    let self = this;
    var config_login = {
      method: "get",
      url: process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/konfig-login",
      headers: {
        Accept: "application/json",
      },
    };
    axios(config_login)
      .then(function (response) {
        var response_data = response.data;
        var response_data_fix = response_data.data;
        if (response_data.meta.code == 200) {
          self.configuration = response_data_fix.referensi;
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response_data_fix.data.message,
          });
        }
      })
      .catch(function (error) {
        console.log(error);
      });

    self.loginCermat();
  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    async loginCermat() {
      try {
        const response = await axios.post(
          process.env.VUE_APP_BACKEND_URL_VERSION + "auth/login-cermat",
          {
            username: this.username,
            role_name: this.role_name,
            token: this.token,
          }
        );
        var data_login = response.data.data;
        if (data_login.status_login == false) {
          Swal.fire({
            icon: "warning",
            title: "Oopss",
            text: data_login.message_login,
            showCancelButton: false,
            showConfirmButton: true,
          });
          Swal.close();
          return;
        }
        // inisialisasi variabel localstorage untuk session
        localStorage.setItem(
          "session_user_id",
          response.data.data.user.user_id
        ); // session user id
        localStorage.setItem(
          "session_username",
          response.data.data.user.username
        ); // session username
        localStorage.setItem("session_name", response.data.data.user.name); // session name
        localStorage.setItem(
          "session_path_photo",
          response.data.data.user.path_photo
        ); // session path photo
        localStorage.setItem("access_token", response.data.data.access_token); // akses token
        localStorage.setItem(
          "session_role",
          JSON.stringify(response.data.data.role)
        ); // session role
        localStorage.setItem(
          "session_role_active_id",
          response.data.data.role[0].role.id_role
        ); // session role active id
        localStorage.setItem(
          "session_role_active_name",
          response.data.data.role[0].role.role_name
        ); // session role active name
        localStorage.setItem("session_role_active_index", 0); // session role active index
        localStorage.setItem(
          "session_menu_access",
          JSON.stringify(response.data.data.menu_access[0].role_menu)
        ); // set session meu access user
        localStorage.setItem("session", JSON.stringify(response.data.data)); // set all response to session
        localStorage.setItem("user", response.data.data.user); // set session user
        localStorage.setItem(
          "configuration",
          JSON.stringify(this.configuration)
        ); // set session configuration
        localStorage.setItem("reload_already", "no");
        localStorage.setItem("dateLogin", Date.now());

        // get role cermat
        await this.getRoleCermat(
          response.data.data.access_token,
          response.data.data.user.username
        );

        let timerInterval;
        Swal.fire({
          icon: "success",
          title: "Berhasil",
          text: "Anda akan diarahkan ke halaman dashboard segera",
          timer: 2000,
          timerProgressBar: true,
          showCancelButton: false,
          showConfirmButton: false,
          willClose: () => {
            clearInterval(timerInterval);
          },
        }).then((result) => {
          /* Read more about handling dismissals below */

          // return false;
          if (
            localStorage.session &&
            localStorage.session_name &&
            localStorage.access_token
          ) {
            if (result.dismiss === Swal.DismissReason.timer) {
              this.$router.push({ name: "dashboard" });
            }
          }
        });
      } catch (error) {
        console.log("error", error);
        var message = error.response.data.data.error;
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: message,
        }).then(() => {
          this.$router.go(-1);
        });
      }
    },
    async getRoleCermat(token, nip) {
      try {
        const response = await axios.get(
          process.env.VUE_APP_API_CERMAT + "role_cermat",
          {
            headers: {
              Authorization: "Bearer " + token,
              Cookie: "ci_session=fp3neb9nmgfgqi4qt87b2c79ujfn9on0",
            },
            params: {
              nip: nip,
            },
          }
        );
        const menuRead = response.data.response_get.menuRead ?? [];
        const menuWrite = response.data.response_get.menuWrite ?? [];
        const nameRoleCermat = response.data.response_get.namaRole;
        const nameLabels = menuRead.map((item) => item.name);
        const nameWriteLabels = menuWrite.map((item) => item.name);

        const filteredMenuItems = await menuItems
          .map((item) => {
            // Filter subItems jika ada
            if (item.subItems) {
              const filteredSubItems = item.subItems.filter((subItem) =>
                nameLabels.includes(subItem.label)
              );
              return filteredSubItems.length > 0
                ? { ...item, subItems: filteredSubItems }
                : null;
            }

            // Kembalikan item utama jika label ada di nameLabels
            if (nameLabels.includes(item.label)) {
              return item;
            }

            // Jika tidak ada kecocokan, kembalikan undefined
            return null;
          })
          .filter((item) => item !== null);

        let filteredNameRoute = [];
        filteredMenuItems.forEach((item) => {
          filteredNameRoute.push(item.label);
          if (item.subItems) {
            item.subItems.forEach((subItem) => {
              filteredNameRoute.push(subItem.label);
            });
          }
        });

        localStorage.setItem("filtered_name_menu", filteredNameRoute);
        localStorage.setItem("role_cermat", nameRoleCermat);
        localStorage.setItem(
          "filtered_menu",
          JSON.stringify(filteredMenuItems)
        );
        localStorage.setItem("menu_read_names", JSON.stringify(nameLabels));
        localStorage.setItem(
          "menu_write_names",
          JSON.stringify(nameWriteLabels)
        );
        console.log("filteredMenuItems", filteredMenuItems);
      } catch (error) {
        console.error("Error fetching role cermat:", error);
      }
    },
  },
};
</script>
